import { createContext } from 'react'

const ValidationStatusContext = createContext({
    setValidated: () => {},
})

export default ValidationStatusContext
